import shortenStr from '../shortenStr';

const categoryConfig = () => {
    return {
        scales: {
            y: {
                type: 'category',
                ticks: {
                    callback: function(val) {
                        const label = this.getLabelForValue(val) || '';
                        return shortenStr(20, label);
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: context => {
                        const rawValue = context[0].label;
                        return rawValue;
                    },
                },
            },
        },
    };
};

export default categoryConfig;
